import { styled } from '@mui/material/styles';

import { Icon } from '../../Icon';

export const StyledIcon = styled(Icon)`
    margin-left: 0.8rem;
`;
